import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import MainLayout from './components/MainLayout.jsx';
import { AppProvider } from './context/AppContext';
import Home from './pages/Home';
import GramPanchayat from './pages/GramPanchayat';
import OurVillage from './pages/OurVillage';
import VillageSectionCardDetails from './components/VillageSectionCardDetails';
import AllAnouncement from './pages/AllAnouncement';
import PhotoGallaryDetails from './pages/PhotoGallaryDetails';
import './App.css';
import SchemesProjects from './pages/SchemesProjects';
import CitizenServices from './pages/citizenServices';
import DigitalLibrary from './pages/DigitalLibrary';
import TransparencyReports from './pages/TransparencyReports';
import Donation from './pages/Donation.jsx';
import Ceremony from './pages/Ceremony.jsx';
import BirthdayWishes from './pages/BirthdayWishes.jsx';
import CeremonyDetail from './pages/CeremonyDetail.jsx';
import BirthdayWishesDetail from './pages/BirthdayWishesDetail.jsx';
import RTI from './pages/RTI.jsx';
import SamruddhaPanchayat from './pages/SamruddhaPanchayat.jsx';
import { initializeVillageTheme } from './utils/themeManager';
import { getCurrentVillageConfig } from './config/villageConfig';

function App() {
  useEffect(() => {
    // Initialize village-specific theme and configuration
    initializeVillageTheme();
    
    // Log current village info for debugging
    const villageConfig = getCurrentVillageConfig();
    console.log('🏘️ Current Village Configuration:', villageConfig);
    console.log('🌐 Domain:', window.location.hostname);
    console.log('🆔 Client ID:', villageConfig.clientId);
    
    // Set document title based on village
    const title = `${villageConfig.englishName}`;
    document.title = title;
    
    // Update meta tags for social media sharing (WhatsApp, Facebook, etc.)
    const updateMetaTag = (property, content) => {
      let meta = document.querySelector(`meta[property="${property}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };
    
    const updateNameMeta = (name, content) => {
      let meta = document.querySelector(`meta[name="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };
    
    // Open Graph tags for WhatsApp/Facebook
    updateMetaTag('og:title', title);
    updateMetaTag('og:site_name', `${villageConfig.englishName} `);
    updateMetaTag('og:description', `Official website of ${villageConfig.englishName} `);
    
    // Twitter Card tags
    updateNameMeta('twitter:title', title);
    updateNameMeta('twitter:description', `Official website of ${villageConfig.englishName} `);
    
    // General meta description
    updateNameMeta('description', `Official website of ${villageConfig.englishName} `);
  }, []);

  return (
    <AppProvider>
      <MainLayout>
        <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/gram-panchayat" element={<GramPanchayat />} />
        <Route path="/our-village" element={<OurVillage />} />
        {/* Nested routes for village sections */}
        <Route path="/our-village/:section" element={<VillageSectionCardDetails />} />
        <Route path="/schemes-projects" element={<SchemesProjects />} />
        <Route path="/citizen-services" element={<CitizenServices />} />
        <Route path="/digital-library" element={<DigitalLibrary />} />
        <Route path="/transparency-reports" element={<TransparencyReports />} />
        <Route path="/all-announcements" element={<AllAnouncement />} />
        <Route path="/photo-gallery" element={<PhotoGallaryDetails />} />
        <Route path="/donation" element={<Donation />} />
        <Route path="/ceremony" element={<Ceremony />} />
        <Route path="/ceremony/:slug" element={<CeremonyDetail />} />
        <Route path="/birthday-wishes" element={<BirthdayWishes />} />
        <Route path="/birthday-wishes/:slug" element={<BirthdayWishesDetail />} />
        <Route path="/rti" element={<RTI />} />
        <Route path="/samruddha-panchayat" element={<SamruddhaPanchayat />} />
        </Routes>
      </MainLayout>
    </AppProvider>
  );
}

export default App;
